<template>
  <div style="overflow: hidden; padding-top: 100px" >
    <b-row class="m-0 justify-content-center mt-4 mb-5">
      <div class="" @click="$router.push('/dashboard').catch(err => {})" >
        <img class="p-0" style="width: 1000px" src="@/assets/logos/eatDorado_de.png" alt="eatDoradoLogo"/> 
      </div>
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center" style="padding-top: 100px">

      <b-col cols="5" >
        <b-row class="m-0 justify-content-center">
          <div class="text-center py-5">
            <div style="width: 400px; height: 400px; border-radius: 20px" class="shadow p-5">
              <h1 class="mb-5">Aktive Restaurants:</h1>
              <span style="font-size: 100px">{{ companyNumber }}</span>
            </div>
          </div>
        </b-row>
      </b-col>
      <b-col cols="5">
         <b-row class="m-0 justify-content-center">
          <div class="text-center py-5">
            <div style="width: 400px; height: 400px; border-radius: 20px" class="shadow p-5">
              <h1 class="mb-5">Bestellungen:</h1>
              <br>
              <br>
              <span style="font-size: 100px">{{ ordersNumber }}</span>
            </div>
          </div>
        </b-row>
      </b-col>
      
    </b-row>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Overview',
  mixins: [coreData],
  components: {

  }, 
  data: () => {
    return {
      numberFrom: 0,
      numberTo: 5000,
      duration: 5,
      scaleClass: false,
      intervalPeriodic: null
    }
  },
  watch: {
    
  },
  computed: {
    companyNumber(){
      return this.$store.getters.companyNumber
    },
    ordersNumber(){
      return this.$store.getters.ordersNumber
    }
  },
  mounted(){
    try {
      this.intervalPeriodic = setInterval( this.getNumbers, 15000);
    } catch (error) {
      console.log(error)
    }
    this.getNumbers()
  },
  beforeDestroy(){
    clearInterval(this.intervalPeriodic)
  },
  methods: {
    getNumbers(){
      this.$store.dispatch('getNumberOrders')
      this.$store.dispatch('getNumberCompany')
    }
  }
}
</script>
<style>

</style>
